export function normalizeUsername(value) {
  return (value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9._-]/g, "")
    .slice(0, 24);
}

export function fallbackUsernameFromEmail(email) {
  const emailPrefix = (email || "").split("@")[0] || "affiliate";
  const normalized = normalizeUsername(emailPrefix);
  return normalized || "affiliate";
}

export function getPublicUsername(record, fallbackEmail = "") {
  return normalizeUsername(record?.username || fallbackUsernameFromEmail(record?.email || fallbackEmail));
}

export function formatPublicHandle(record, fallbackEmail = "") {
  return `@${getPublicUsername(record, fallbackEmail)}`;
}
